import { Grid, Typography } from "@material-ui/core";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

// Update log
// FB  6192   02/06/2023  DK  Common Closure page for PE workflows

interface propState {
    origin: string;
}

export default function ClosurePage(props: any) {
    const location = useLocation();
    let { origin } = location.state as propState;
    return (
        <Box sx={{
            width: "100%",
            padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
        }}>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "2%",
                    }}
                >
                    <Typography variant={window.innerWidth < 768 ? "subtitle1" : "h5"}>
                        {origin === "upload" ? "Please close this tab to continue." : "Thank you for booking an appointment with us. Have a great day!"}
                    </Typography>
                </Grid>
            </Grid>
        </Box >
    )
}